// extracted by mini-css-extract-plugin
export default {"areaList":"AreaList_areaList__hPFhP","isScrolling":"AreaList_isScrolling__P0oJH"};